import { useState, ReactNode } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import useAuthStore from "@/store/authStore";
import { useNavigate } from "react-router-dom";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-[#f4f4f4]">
      <Header
        onMenuClick={() => setMobileSidebarOpen(true)}
        onLogout={() => {
          logout();
          navigate("/login");
        }}
      />
      <div className="flex flex-1">
        <Sidebar
          mobileOpen={mobileSidebarOpen}
          setMobileOpen={setMobileSidebarOpen}
        />
        <main className="flex-1 px-2 md:p-6 overflow-auto m-2 md:m-5">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
}
